import React, { useState } from "react";
import { IoNotifications } from "react-icons/io5";
import DropdownList from "../NavbarComponents/DropdownList";
// import ButtonInstall from "./ButtonInstall"

export default function ListRight({ unreadCount, notifications }) {
  const [display, setDisplay] = useState(false);
  return (
    <>
      <li className="tyn-appbar-item">
        <button
          className="tyn-appbar-link tyn-appbar-link-notification btn dropdown-toggle position-relative btn-dropdown-menu-user"
          data-bs-toggle="dropdown"
          disabled={display}
          onClick={() => {
            setDisplay(!display);
          }}
          data-bs-offset="0,10"
          data-bs-auto-close="outside"
        >
          <>
            <IoNotifications
              className={`${
                unreadCount > 0 &&
                "animate__animated animate__infinite animate__wobble"
              }`}
            />
            {unreadCount > 0 && (
              <span
                className="position-absolute badge rounded-pill bg-danger"
                style={{
                  top: "2px",
                  right: "2px",
                  fontSize: "10px",
                  minWidth: "18px",
                }}
              >
                {unreadCount > 99 ? "99+" : unreadCount}
              </span>
            )}
          </>
        </button>
        <DropdownList
          display={display}
          setDisplay={setDisplay}
          notifications={notifications}
        />
      </li>
      {/* <li className="tyn-appbar-item"><ButtonInstall/></li> */}
    </>
  );
}
